import { useEffect, useState } from "react";
import { RainPhase, FrozenDrop, FinalStats } from "./RainEndPhase";
import { RainStage } from "./RainStage";
import { RainContributor } from "./useRainWebSocket";

interface RainEndSequenceProps {
  finalStats: FinalStats;
  contributors: RainContributor[];
  frozenDrops: FrozenDrop[];
  topContributors?: {
    twitch_id: string;
    twitch_name: string;
    totalContributed: number;
  }[];
  onDone: () => void;
}

export function RainEndSequence({
  finalStats,
  contributors,
  frozenDrops,
  topContributors,
  onDone,
}: RainEndSequenceProps) {
  const [phase, setPhase] = useState<RainPhase>("freeze");

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase("vortex"), 200),
      setTimeout(() => setPhase("energyCore"), 1000),
      setTimeout(() => setPhase("explosion"), 1300),
      setTimeout(() => setPhase("rewardScreen"), 2000),
      setTimeout(() => setPhase("awardFeed"), 7000),
      setTimeout(() => setPhase("fadeOut"), 12000),
      setTimeout(() => setPhase("done"), 12500),
      setTimeout(() => onDone(), 13000),
    ];

    return () => timers.forEach(clearTimeout);
  }, [onDone]);

  return (
    <RainStage
      phase={phase}
      frozenDrops={frozenDrops}
      finalStats={finalStats}
      contributors={contributors}
      topContributors={topContributors}
    />
  );
}
